import { create } from "zustand";

export const useTitleHeaderStore = create()((set) => ({
  titleHeader: "Portfolio",
  preferenceSettings: { isConfiged: false, subjects: [], isLoaded: false },
  setTitleHeader: (titleHeader: string) => {
    return set({ titleHeader });
  },
}));

export const setTitleHeader = (titleHeader: string) => {
  return useTitleHeaderStore.setState({
    titleHeader: titleHeader ?? "",
  });
};
